

const SuccessUrl = () => {
    return (
        <>
            <h1>success</h1>
        </>
    )
}


export { SuccessUrl }